module.exports = __webpack_public_path__ + "static/img/mg-kasuga.5bc04b9.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/works/mg-kasuga.jpg
 ** module id = 21
 ** module chunks = 1
 **/